import React from 'react';
import ReactDOM from 'react-dom/client';
import Inialize from './Initialize';

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<Inialize />
	</React.StrictMode>
);
